import { section } from '@/glow';
import { on } from '@/glow/events';
import { qs } from '@fluorescent/dom';
import Carousel from '@/lib/carousel';
import AnimateProductItem from '@/lib/product-item';
import { AnimateFeaturedCollectionRow } from '@/lib/animation';

const selectors = {
  slider: '[data-slider]',
};

section('featured-collection-row', {
  events: [],
  onLoad() {
    this.sliderElement = qs(selectors.slider, this.container);
    this.sliderElement.style.opacity = 0;
    this.carousel = Carousel(this.container, 'featured-collection-row', {
      wrapAround: false,
      adaptiveHeight: false,
      onReady: () => {
        this.animateProductItem = AnimateProductItem(this.container);
        this.AnimateFeaturedCollectionRow = AnimateFeaturedCollectionRow(this.container);
      }
    });

    this.events.push(
      on('featured-collection-row:initialized', () => {
        if (!window.matchMedia('(min-width: 45em)').matches) {
          this.carousel.select(1);
        }
      })
    );
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
    this.carousel && this.carousel.destroy();
    this.animateProductItem && this.animateProductItem.destroy();
    this.AnimateFeaturedCollectionRow?.destroy();
  },
});
